import { render, staticRenderFns } from "./ReportTerminalsDetail.vue?vue&type=template&id=64d9d07b&scoped=true&"
import script from "./ReportTerminalsDetail.vue?vue&type=script&lang=js&"
export * from "./ReportTerminalsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportTerminalsDetail.vue?vue&type=style&index=0&id=64d9d07b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9d07b",
  null
  
)

export default component.exports